module.exports = __webpack_public_path__ + "img/icons B_8.fe80dbb6.svg";